

export const jobsData = [
//   {
//     id: 1,
//     title: "Senior Automotive Technician",
//     category: "Workshop",
//     location: "Industrial Area, Nairobi",
//     type: "Full-Time",
//     salary: "KES 80k - 120k / month",
//     postedAt: "2 days ago",
//     description: "We are looking for a master technician with 7+ years of experience in German and Japanese vehicles. Must be proficient in advanced diagnostics.",
//     slug: "senior-technician"
//   },
//   {
//     id: 2,
//     title: "Service Advisor",
//     category: "Customer Service",
//     location: "Westlands Branch",
//     type: "Full-Time",
//     salary: "Competitive",
//     postedAt: "1 week ago",
//     description: "The bridge between our mechanics and our clients. You need excellent communication skills and technical understanding of vehicle repairs.",
//     slug: "service-advisor"
//   },
//   {
//     id: 3,
//     title: "Auto Electrician",
//     category: "Workshop",
//     location: "Mombasa Road",
//     type: "Contract",
//     salary: "Based on Experience",
//     postedAt: "3 days ago",
//     description: "Specialist needed for wiring, ECU remapping, and hybrid battery diagnostics. Certification in EV systems is a plus.",
//     slug: "auto-electrician"
//   },
//   {
//     id: 4,
//     title: "Workshop Manager",
//     category: "Management",
//     location: "Industrial Area",
//     type: "Full-Time",
//     salary: "Negotiable",
//     postedAt: "Just now",
//     description: "Lead a team of 15+ mechanics. Responsible for quality control, workflow management, and inventory oversight.",
//     slug: "workshop-manager"
//   },
//   {
//     id: 5,
//     title: "Junior Mechanic (Internship)",
//     category: "Workshop",
//     location: "All Locations",
//     type: "Internship",
//     salary: "Stipend Provided",
//     postedAt: "2 weeks ago",
//     description: "Start your career with the best. We offer a 6-month intensive training program for recent technical college graduates.",
//     slug: "junior-mechanic-intern"
//   }
];